import { DEFAULT_GEODE } from './constants';
import { defaultLevel } from '../config/env';

export type PendingDropItem = {
  name: string;
  quantity: number;
  category?: string;
};

export type GeodeSyncEntry = {
  geodeType: string;
  hp: number;
  geodeId: string | number | null;
  combatSeed: number | null;
  tapsApplied: number;
  pendingDrops: { dust: number; item: PendingDropItem | null };
  unackedTaps: number;
  awaitingBreakAck: boolean;
};

/** Visual theme uses Booga Town art; API location comes from env (DEMO vs Booga Town). */
export const gameSyncState = {
  levelName: defaultLevel,
  weaponIdByName: {} as Record<string, number>,
  geodeEntry: null as GeodeSyncEntry | null,
  dustCollected: 0,
  equippedWeaponId: null as number | null,
  backendSynced: false,
  appVisible: true,
  energyRegenSeconds: 300,
  /** Dust pieces still flying — each pickup/auto-collect reveals +1. */
  pendingBreakDust: 0,
  /** Last profile.dust from server (for break grant delta). */
  lastServerProfileDust: 0,
  /** Pending loot on geode when local break fired (before PATCH ack). */
  breakLootSnapshot: 0,
};

export function getGeodeSyncEntry(): GeodeSyncEntry | null {
  return gameSyncState.geodeEntry;
}

/** Local-only placeholder when backend is off. */
export function ensureLocalGeodeEntry(): GeodeSyncEntry {
  if (!gameSyncState.geodeEntry) {
    gameSyncState.geodeEntry = {
      geodeType: DEFAULT_GEODE,
      hp: 49,
      geodeId: null,
      combatSeed: null,
      tapsApplied: 0,
      pendingDrops: { dust: 0, item: null },
      unackedTaps: 0,
      awaitingBreakAck: false,
    };
  }
  return gameSyncState.geodeEntry;
}

export function clearGeodeEntry() {
  gameSyncState.geodeEntry = null;
}

/** Remember pending loot when the geode breaks locally (before server ack). */
export function snapshotBreakLoot() {
  const dust = gameSyncState.geodeEntry?.pendingDrops?.dust ?? 0;
  if (dust > 0) gameSyncState.breakLootSnapshot = dust;
}

/** Dust sprites to scatter for the geode that just broke. */
export function breakDustParticleCount(): number {
  return Math.max(
    gameSyncState.breakLootSnapshot,
    gameSyncState.geodeEntry?.pendingDrops?.dust ?? 0,
  );
}

export function clearBreakLootSnapshot() {
  gameSyncState.breakLootSnapshot = 0;
}
